const print = {
  namespaced: true,
  state: {
    title: '' // 印刷タイトル
  },
  getters: {
  },
  mutations: {
    setTitle(state, title) {
      state.title = title
    }
  },
  actions: {
    setTitle({ commit }, title) {
      commit('setTitle', title)
    }
  }
}

export default print
